import StatusBanner, { STATUS_BANNER_TYPE_ENUM } from './status-banner';

export default StatusBanner;
export { StatusBanner, STATUS_BANNER_TYPE_ENUM };
